import { render, staticRenderFns } from "./CustomerClaimList.vue?vue&type=template&id=6f222234&"
import script from "./CustomerClaimList.vue?vue&type=script&lang=js&"
export * from "./CustomerClaimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports